import React from 'react';
import { Link } from 'react-router-dom';
import useGetMyManagementByPrestacion, { PrestacionManagement } from 'services/management/useGetMyManagementByPrestacion';
import LoaderMin from 'components/blocks/Loader/LoaderMin';
import Icon from 'components/blocks/Icon/Icon';
import NoData from 'components/pages/noData/NoData';
import 'components/pages/Management/Management.scss';

const uniqueById = (arr: PrestacionManagement[]) => {
    if (!Array.isArray(arr)) return [];
    return arr.filter(
        (item, index, self) =>
            index === self.findIndex(candidate => candidate.Id === item.Id)
    );
};

interface FormPrestacionActivaProps {
    expedienteId: string | number | null;
}

export const FormPrestacionActiva = ({ expedienteId }: FormPrestacionActivaProps) => {
    const { items, groups, loading, error, expedienteId: currentExpedienteId } = useGetMyManagementByPrestacion(expedienteId);

    if (loading) {
        return <div className="mgmt-loading"><LoaderMin /></div>;
    }

    if (error) {
        return <NoData message="No se pudieron cargar los formularios de la prestación." />;
    }

    if (!currentExpedienteId) {
        return <NoData message="No hay un expediente disponible para consultar formularios." />;
    }

    const itemsFiltrados = items.filter(item => item.Tipo === 3);

    const gruposFiltrados = groups
            .map(grupo => ({
                ...grupo,
                Gestiones: uniqueById(grupo.Gestiones).filter(gestion => gestion.Tipo === 3)
            }))
            .filter(grupo => grupo.Gestiones.length > 0);

    if (itemsFiltrados.length === 0 && gruposFiltrados.length === 0) {
        return <NoData message="No hay formularios de la prestación activa." />;
    }

    return (
        <div>
            {itemsFiltrados.length > 0 && (
                <div className="mgmt-cards-grid">
                    {itemsFiltrados.map((item, i: number) => (
                        <article key={i} className="mgmt-item-card mgmt-item-card--static">
                            <div className="mgmt-item-card__icon mgmt-item-card__icon--form">
                                <Icon name="file-text" size={20} />
                            </div>
                            <div className="mgmt-item-card__body">
                                <div className="mgmt-item-card__title">{item.Titulo}</div>
                                {item.Descripcion && (
                                    <div className="mgmt-item-card__desc">{item.Descripcion}</div>
                                )}
                            </div>
                            <div className="mgmt-item-card__action">
                                <Link
                                    to="/mis-gestiones/formularios"
                                    state={{ titulo: item.Titulo, id: item.Id, origen: 1, expedienteId }}
                                    className="mgmt-item-card__btn"
                                >
                                    Abrir <Icon name="arrow-right" size={13} />
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>
            )}

            {gruposFiltrados.map((grupo, i: number) => (
                <div key={i} className="mgmt-group">
                    <div className="mgmt-group__header">
                        <div className="mgmt-group__title">{grupo.Titulo}</div>
                        {grupo.Descripcion && <p className="mgmt-group__desc">{grupo.Descripcion}</p>}
                    </div>
                    <div className="mgmt-cards-grid">
                        {grupo.Gestiones.map((item, j: number) => (
                            <article key={j} className="mgmt-item-card mgmt-item-card--static">
                                <div className="mgmt-item-card__icon mgmt-item-card__icon--form">
                                    <Icon name="file-text" size={20} />
                                </div>
                                <div className="mgmt-item-card__body">
                                    <div className="mgmt-item-card__title">{item.Titulo}</div>
                                    {item.Descripcion && (
                                        <div className="mgmt-item-card__desc">{item.Descripcion}</div>
                                    )}
                                </div>
                                <div className="mgmt-item-card__action">
                                    <Link
                                        to="/mis-gestiones/formularios"
                                        state={{ titulo: item.Titulo, id: item.Id, origen: 1, expedienteId }}
                                        className="mgmt-item-card__btn"
                                    >
                                        Abrir <Icon name="arrow-right" size={13} />
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FormPrestacionActiva;
